<!doctype html>
<html lang="en">
	<head>
		<meta charset="UTF-8" />
		<title>Title</title>
	</head>
	<body>
		<div class="wrapper">
			<div class="backdrop">
				<stages-dialog2 [dialogAriaLabel]="'disclaimer.heading' | translate" #dialog>
					<stages-dialog-header [showCloseButton]="false" class="disclaimer-header">
						<span class="h1" [translate]="'disclaimer.heading'"></span>
					</stages-dialog-header>
					<div class="content scroll-content" (scroll)="enableAcceptButton()" #disclaimerTextElement id="x">
						<div class="panel">
							@if (!fileError) {
								<div class="stages_description" [innerHTML]="textContent | safe: 'html'"></div>
							}
							@if (fileError) {
								<div class="stages_description error" [innerHTML]="textContent | safe: 'html'"></div>
								<br />
								<span [translate]="'disclaimer.file.error'"></span>
							}
						</div>
					</div>
					<footer>
						<stages-buttons-bottom [removeBoundaries]="true">
							@if (!fileError) {
								<stages-button [title]="'decline'" [buttonClasses]="'sm cancel'" (clicked)="logOutUser()" />
								<stages-button
									[disabled]="!acceptButtonVisible"
									[buttonType]="'submit'"
									[title]="'accept'"
									[buttonClasses]="'sm save'"
									(clicked)="acceptTerms()"
								/>
							}
							@if (fileError) {
								<stages-button
									[buttonType]="'submit'"
									[title]="'ok'"
									[buttonClasses]="'sm save'"
									(clicked)="logOutUser()"
								/>
							}
						</stages-buttons-bottom>
					</footer>
				</stages-dialog2>
			</div>
		</div>
	</body>
</html>
